/* Caboza — base interactions */

document.addEventListener('DOMContentLoaded', () => {
  // Quantity steppers
  document.querySelectorAll('[data-qty-wrap]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10);
        const current = parseInt(input.value || '1', 10);
        const next = Math.max(parseInt(input.min || '1', 10), current + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Cart item line quantity update
  document.querySelectorAll('.cart-item__quantity input').forEach((input) => {
    input.addEventListener('change', async (e) => {
      const line = e.target.closest('.cart-item');
      if (!line) return;
      const key = line.dataset.key;
      const qty = parseInt(e.target.value, 10);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (res.ok) window.location.reload();
      } catch (err) { console.error(err); }
    });
  });

  // Product image gallery — click thumb to swap main
  const thumbs = document.querySelectorAll('[data-product-thumb]');
  const main = document.querySelector('[data-product-main-image]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      const src = thumb.dataset.src;
      if (main && src) main.src = src;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Mobile menu drawer
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileClosers = document.querySelectorAll('[data-mobile-menu-close]');

  const openMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-menu-open');
  };
  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
  };

  mobileToggle?.addEventListener('click', openMobileMenu);
  mobileClosers.forEach((el) => el.addEventListener('click', closeMobileMenu));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu?.getAttribute('aria-hidden') === 'false') {
      closeMobileMenu();
    }
  });

  // Drawers (reassurance "tiroir")
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const closeBtn = d.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  };
  const closeDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer[aria-hidden="false"]')) {
      document.body.classList.remove('drawer-open');
    }
  };
  document.querySelectorAll('[data-drawer-open]').forEach((el) => {
    el.addEventListener('click', () => openDrawer(el.dataset.drawerOpen));
  });
  document.querySelectorAll('[data-drawer-close]').forEach((el) => {
    el.addEventListener('click', () => closeDrawer(el.dataset.drawerClose));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer[aria-hidden="false"]').forEach((d) => closeDrawer(d.id));
    }
  });

  // Slideshow
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const dots = root.querySelectorAll('[data-slideshow-dot]');
    if (!track) return;
    const slides = track.children.length;
    let i = 0;
    const go = (n) => {
      i = (n + slides) % slides;
      track.style.transform = `translateX(${-i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    };
    dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.slideshowDot, 10))));
    go(0);
    const speed = parseInt(root.dataset.autoplay, 10);
    if (speed && slides > 1) {
      setInterval(() => go(i + 1), speed * 1000);
    }
  });

  // Bundle picker sur page produit : click sur card → MAJ variant id + prix bouton
  document.querySelectorAll('[data-bundle-picker]').forEach((picker) => {
    const cards = picker.querySelectorAll('.bundle-card');
    const variantInput = document.querySelector('[data-variant-input]');
    const priceEl = document.querySelector('[data-atc-price]');

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (card.disabled) return;
        cards.forEach((c) => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        if (variantInput) variantInput.value = card.dataset.variantId;
        if (priceEl) {
          const price = card.dataset.variantPrice;
          if (price) priceEl.innerHTML = `${price}&nbsp;€`;
        }
      });
    });
  });

  // Accordéons footer : ouverts sur desktop, fermés sur mobile par défaut
  const syncFooterAccordions = () => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    document.querySelectorAll('[data-footer-accordion]').forEach((details) => {
      if (isMobile) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  };
  syncFooterAccordions();
  let footerResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(footerResizeTimer);
    footerResizeTimer = setTimeout(syncFooterAccordions, 150);
  });

  // Drag-to-scroll : sur desktop, click+drag horizontal pour glisser le carrousel.
  // Avec [data-infinite] : carrousel en boucle (clones de chaque côté + jump silencieux).
  document.querySelectorAll('[data-drag-scroll]').forEach((track) => {
    const isInfinite = track.hasAttribute('data-infinite');
    const originals = Array.from(track.children);
    const CLONE_COUNT = Math.min(originals.length, 3);

    // Helpers infinite
    const centerOnItem = (item, smooth = false) => {
      if (!item) return;
      const target = item.offsetLeft - track.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
      const prevBehavior = track.style.scrollBehavior;
      if (!smooth) track.style.scrollBehavior = 'auto';
      track.scrollLeft = target;
      if (!smooth) {
        // Restore on next frame
        requestAnimationFrame(() => { track.style.scrollBehavior = prevBehavior; });
      }
    };

    if (isInfinite && originals.length > 1) {
      // Reconstruit le track : [N dernières clonées] [originales] [N premières clonées]
      const makeClone = (node, position) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = position;
        return clone;
      };
      const startClones = originals.slice(-CLONE_COUNT).map((c) => makeClone(c, 'start'));
      const endClones = originals.slice(0, CLONE_COUNT).map((c) => makeClone(c, 'end'));

      // Vide et reconstruit dans l'ordre
      while (track.firstChild) track.removeChild(track.firstChild);
      [...startClones, ...originals, ...endClones].forEach((node) => track.appendChild(node));

      // Position initiale : centre sur la 1ère carte originale (après les clones de début)
      const initPosition = () => {
        const items = Array.from(track.children);
        const firstOriginal = items[CLONE_COUNT];
        centerOnItem(firstOriginal, false);
      };
      // Attendre le rendu pour avoir les bonnes dimensions
      requestAnimationFrame(initPosition);
      window.addEventListener('load', initPosition);

      // Sur scroll : détecte si on est sur un clone et jump à l'original équivalent
      let snapTimer;
      const handleScrollEnd = () => {
        const items = Array.from(track.children);
        const centerX = track.scrollLeft + track.clientWidth / 2;
        let closestIdx = 0;
        let minDist = Infinity;
        items.forEach((item, i) => {
          const itemCenter = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
          const dist = Math.abs(itemCenter - centerX);
          if (dist < minDist) { minDist = dist; closestIdx = i; }
        });
        const closestItem = items[closestIdx];
        if (!closestItem) return;

        if (closestItem.dataset.clone === 'end') {
          // Saut vers l'original équivalent (en début de la liste originale)
          const originalIdx = CLONE_COUNT + (closestIdx - CLONE_COUNT - originals.length);
          centerOnItem(items[originalIdx], false);
        } else if (closestItem.dataset.clone === 'start') {
          // Saut vers l'original équivalent (en fin de la liste originale)
          const originalIdx = CLONE_COUNT + originals.length - (CLONE_COUNT - closestIdx);
          centerOnItem(items[originalIdx], false);
        }
      };
      track.addEventListener('scroll', () => {
        clearTimeout(snapTimer);
        snapTimer = setTimeout(handleScrollEnd, 120);
      });
    }

    // Drag-to-scroll (commun à tous les tracks data-drag-scroll)
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;

    const onPointerDown = (e) => {
      if (e.target.closest('a, button, input, select, textarea')) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    };
    const onPointerMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScrollLeft - dx;
    };
    const onPointerUp = () => {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('mousedown', onPointerDown);
    track.addEventListener('mousemove', onPointerMove);
    track.addEventListener('mouseup', onPointerUp);
    track.addEventListener('mouseleave', onPointerUp);

    track.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  // Sliders horizontaux avec dots (réassurances icônes notamment)
  document.querySelectorAll('[data-slider]').forEach((root) => {
    const track = root.querySelector('[data-slider-track]');
    const dots = root.querySelectorAll('[data-slider-dot]');
    if (!track || !dots.length) return;

    const items = Array.from(track.children);

    // Click sur un dot → scroll vers la slide correspondante
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        const target = items[idx];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    // Update dot actif sur scroll
    let timeout;
    const updateActiveDot = () => {
      const scrollLeft = track.scrollLeft + track.clientWidth / 2;
      let closestIdx = 0;
      let minDist = Infinity;
      items.forEach((item, i) => {
        const center = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
        const dist = Math.abs(center - scrollLeft);
        if (dist < minDist) { minDist = dist; closestIdx = i; }
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === closestIdx));
    };
    track.addEventListener('scroll', () => {
      clearTimeout(timeout);
      timeout = setTimeout(updateActiveDot, 80);
    });
  });

  // Hotspots
  document.querySelectorAll('[data-hotspots]').forEach((wrap) => {
    const hotspots = wrap.querySelectorAll('[data-hotspot]');
    const popovers = wrap.querySelectorAll('[data-hotspot-popover]');
    hotspots.forEach((h) => {
      h.addEventListener('click', (e) => {
        e.stopPropagation();
        const idx = h.dataset.hotspot;
        hotspots.forEach((x) => x.classList.remove('is-active'));
        popovers.forEach((p) => p.classList.remove('is-open'));
        h.classList.add('is-active');
        const pop = wrap.querySelector(`[data-hotspot-popover="${idx}"]`);
        if (pop) pop.classList.add('is-open');
      });
    });
    document.addEventListener('click', () => {
      hotspots.forEach((x) => x.classList.remove('is-active'));
      popovers.forEach((p) => p.classList.remove('is-open'));
    });
  });
});

/* ============================================
   SIDE CART DRAWER
   - ouvre/ferme via data-cart-drawer-open / data-cart-drawer-close
   - quantité, suppression, ajout (cross-sell + ATC produit) en AJAX
   - re-rend le drawer via /?sections=cart-drawer après chaque mutation
   ============================================ */
(function () {
  const root = document;
  const drawerSelector = '[data-cart-drawer]';
  const COUNT_SEL = '[data-cart-count]';

  function getDrawer() { return root.querySelector(drawerSelector); }

  function openDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }
  function closeDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  async function refreshDrawer() {
    const res = await fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();
    const html = data['cart-drawer'];
    if (!html) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fresh = doc.querySelector(drawerSelector);
    const current = getDrawer();
    if (fresh && current) {
      // Préserve l'état d'ouverture
      const wasOpen = current.classList.contains('is-open');
      current.replaceWith(fresh);
      if (wasOpen) {
        fresh.classList.add('is-open');
        fresh.setAttribute('aria-hidden', 'false');
      }
    }
    // Met à jour le badge de quantité du header
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll(COUNT_SEL).forEach((el) => { el.textContent = cart.item_count; });
    } catch (e) { /* ignore */ }
  }

  // Délégation globale : open/close
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }
    const closer = e.target.closest('[data-cart-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(); return; }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // Quantité : boutons +/- et input
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const wrap = step.closest('[data-qty-wrap][data-key]');
    if (!wrap) return;
    e.preventDefault();
    const input = wrap.querySelector('[data-qty-input]');
    const delta = parseInt(step.dataset.qtyStep, 10) || 0;
    const newQty = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    await updateLine(wrap.dataset.key, newQty, wrap);
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const wrap = input.closest('[data-qty-wrap][data-key]');
    if (!wrap) return;
    const newQty = Math.max(0, parseInt(input.value, 10) || 0);
    await updateLine(wrap.dataset.key, newQty, wrap);
  });

  // Bouton "retirer" (X)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    await updateLine(btn.dataset.cartRemove, 0, btn);
  });

  async function updateLine(key, quantity, loaderTarget) {
    setLoading(loaderTarget, true);
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      await refreshDrawer();
    } finally {
      // Le DOM a été remplacé par refreshDrawer, mais on nettoie au cas où l'erreur a empêché le swap.
      setLoading(loaderTarget, false);
    }
  }

  // Loader sur les CTA pendant l'AJAX add-to-cart
  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  // Cross-sell : ajout produit
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"]');
    setLoading(submitBtn, true);
    try {
      const fd = new FormData(form);
      await fetch('/cart/add.js', { method: 'POST', body: fd });
      await refreshDrawer();
      openDrawer();
    } finally {
      setLoading(submitBtn, false);
    }
  });

  // ATC produit (fiche produit) : intercepte si le drawer est dispo
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form || form.matches('[data-cart-add-form]')) return; // déjà géré au-dessus
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    setLoading(submitBtn, true);
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) {
        // En cas d'échec, fallback sur soumission native
        form.submit();
        return;
      }
      await refreshDrawer();
      openDrawer();
    } finally {
      setLoading(submitBtn, false);
    }
  });
})();
